import { render, staticRenderFns } from "./EstateAgentYN.vue?vue&type=template&id=8fd56808"
import script from "./EstateAgentYN.vue?vue&type=script&lang=js"
export * from "./EstateAgentYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports